import React, { Component } from 'react'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'
import TextField from 'material-ui/TextField';
import {myConfig} from '../config/myConfig'


//const blueColor= 'rgb(34, 154, 168)' //#229aa8


class DialogPlaces extends Component {
  state = {
    placesViewDisplay:false,
    placesView :[]
  }

  clearData = () => this.setState({placesView:[],placesViewDisplay:false})

  render() {

    return (
      <div style={{width:'100%'}}>


        <Dialog
        bodyStyle={{width:'100%',maxWidth:600,overflow:'visible'}}
          contentStyle={{width:'100%',maxWidth:600,overflow:'visible'}}
          modal={false}
          autoScrollBodyContent={true}
          open={this.props.openModal}
          onRequestClose={()=>{
            this.setState({placesViewDisplay:false})
            this.props.closeModal()
          }}>



          <div style={{position:'relative',width:'100%',}}>


            <TextField
              hintText="Paris"
              floatingLabelText="Entrez votre ville"
              fullWidth
              //floatingLabelStyle={{color:'white'}}
              defaultValue={this.state.planceInput}
              // inputStyle={{margin:0,padding:0}}
              onChange={(e)=>{
                this.setState({placeInput : e.target.value})

                const url = `https://api.institutsounnah.net/places?q=${e.target.value}`
                  fetch(url)
                  .then( response => response.json() )
                    .then(json => {
                      //fetch(`http://api.institutsounnah.net/places?q=${e.target.value}`)

                    this.setState({
                      placesViewDisplay:true,
                      placesView:json
                      // [{"name":"Paris","lat":48.85459999999999780584403197281062602996826171875,"lng":2.347700000000000120081722343456931412220001220703125},
                      // {"name":"Paris 1er Arrondissement","lat":48.8599999999999994315658113919198513031005859375,"lng":2.341299999999999936761696517351083457469940185546875},
                      // {"name":"Montrouge","lat":48.8164000000000015688783605583012104034423828125,"lng":2.321099999999999941024952931911684572696685791015625},
                      // {"name":"Levallois-Perret","lat":48.89320000000000021600499167107045650482177734375,"lng":2.28770000000000006679101716144941747188568115234375},
                      // {"name":"Saint-Ouen","lat":48.90690000000000026147972675971686840057373046875,"lng":2.332899999999999973709918776876293122768402099609375},
                      // {"name":"Clichy","lat":48.9035999999999972942532622255384922027587890625,"lng":2.305400000000000115818465928896330296993255615234375},
                      // {"name":"Marseille","lat":43.295400000000000773070496506989002227783203125,"lng":5.36310000000000020037305148434825241565704345703125},
                      // {"name":"Marseille 10e Arrondissement","lat":43.28009999999999735109668108634650707244873046875,"lng":5.42537000000000002586375558166764676570892333984375},
                      // {"name":"Lyon","lat":45.7539000000000015688783605583012104034423828125,"lng":4.8469899999999999096189640113152563571929931640625},
                      // {"name":"Lyon 1er Arrondissement","lat":45.76939999999999741930878371931612491607666015625,"lng":4.83011999999999996902033672085963189601898193359375},
                      // {"name":"Toulouse","lat":43.60430000000000205773176276125013828277587890625,"lng":1.441990000000000105018216345342807471752166748046875},
                      // {"name":"Nice","lat":43.70190000000000196678229258395731449127197265625,"lng":7.2683099999999996043698047287762165069580078125}]

                    })

                })

                }
              }
            >


            </TextField>



          {this.state.placesViewDisplay &&
            <div style={{position:'absolute',width:'100%',border:'2px solid ',borderColor:myConfig.blueLight,color:myConfig.blueLight,right:0,top:72,backgroundColor:'white',zIndex:1000000000000}}>
              {this.state.placesView.map((place,i)=>
                <p key={i} style={{cursor:'pointer',padding:5}} onClick={()=>{
                  this.props.setPlace(place)
                  this.clearData()
                }}>{place.name} - {place.zipcode}</p>
              )}
            </div>
          }



          {/* <FlatButton
       label="Annuler"
       style={{float:'right',marginTop:30}}
       primary={true}
       onClick={()=>{
         this.clearData()
         this.props.closeModal()
       }}
     /> */}


</div>


        </Dialog>



      </div>
    )
  }

}

export default DialogPlaces



// WEBPACK FOOTER //
// ./src/components/DialogPlaces.jsx